/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: field-system-edit-view-component.ts
 *
 * Created by kyang on 2020-09-11.
 */

function FileSystemEditViewController (
    this: JS5Object,
    $location: JS5Object,
    $route: JS5Object,
    $routeParams: JS5Object,
    BreadcrumbService: JS5Object,
    FileSystemEditService: JS5Object,
    NotificationService: JS5Object,
    PermissionsService: JS5Object
) {

    this.getBreadcrumbName = () => {
        return _.get(FileSystemEditService, 'originalEditData.name', 'Edit File System');
    };

    this.editingNewFileSystem = () => {
        return $routeParams.id === '-1';
    };

    //=================//
    // Tab Definitions //
    //=================//

    this.setActiveTab = (newTab: string) => {
        this.currentTab = newTab;
    };

    this.onTabSelect = (newTab: string) => {
        $route.updateParams({editView: newTab});
    };

    this.onTabDeselect = ($event: JS5Object) => {
        if (!_.get(FileSystemEditService, 'editorForm.$pristine', true)) {
            $event.preventDefault();
            NotificationService.createWarningNotification(
                'You have unsaved changes. Please save or revert.', '');
        }
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        if (!PermissionsService.isAdmin()) {
            $location.url('/login');
        } else {
            BreadcrumbService.clearBreadcrumbs();
            BreadcrumbService.addBreadcrumb({
                location: '/system/fileSystems/search',
                name: 'File Systems',
            });
            this.setActiveTab($routeParams.editView || 'properties');
        }
    };
}

angular.module('prism-ui.fileSystem').component('fileSystemEditView', {
    templateUrl: 'system/fileSystem/editView/file-system-edit-view-template.html',
    controller: FileSystemEditViewController
});
